export class UserData {
  public accessRole: AccessRole;
  public userId: number;
  public userAccountId: number;
  public clubId: number;
  public affiliateId: number;
  public isSuperAdmin: boolean;
  public user: LoginUser;

  get isUser(): boolean {
    return this.accessRole === AccessRole.User;
  }

  isAdministrator(): boolean {
    return this.accessRole === AccessRole.Administrator || this.accessRole === AccessRole.EventAdministrator;
  }
}

export enum ClubApproveStatus {
  Unknown = -1,
  NotApproved,
  Approved,
  Blocked,
}

export enum AccessRole {
  NoAccess = 0,
  Administrator = 1,
  User = 2,
  Limited = 3,
  Finance = 4,
  EventAdministrator = 7,
}

export class LoginUser {
  public firstName: string;
  public lastName: string;
  public fullName: string;
  public email: string;
  public mobile: string;
}
